module.exports = __webpack_public_path__ + "img/guitar.e5bea8fa.png";